export default () => {
  if ($('body.notifications.index').length === 0) return

  const $form = $('form.notifications-filter')
  $form.on('change', () => $form.submit())
}
